import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { dates } from '@/shared/utils/dates';

type FieldDateProps = {
  date?: Date;
};

export const FieldDate: FC<FieldDateProps> = ({ date }) => {
  if (!date) {
    return <Container>-</Container>;
  }

  return (
    <Container>
      <Date>{dates.formatDate2(date)}</Date>
      <Time>{dates.formatTime(date)}</Time>
    </Container>
  );
};

const Container = styled.div`
  max-width: 100px;
  width: 100px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Date = styled.div`
  height: 20px;
  line-height: 20px;
`;

const Time = styled.div`
  height: 16px;
  font-size: 12px;
  line-height: 16px;
  color: ${COLORS.systemDark200};
`;
